import { SVGProps, Ref, forwardRef } from 'react';

export const CraneFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.833 13.333c0 1.257 0 1.886-.39 2.276-.391.39-1.02.391-2.276.391l-.831-.006c-.665-.017-1.08-.08-1.37-.316l-.075-.069C.5 15.22.5 14.59.5 13.333v-6.91h5.331z"
                fill="currentColor"
            />
            <path
                d="m11.367 8.694.131.001c.725.019 1.152.093 1.444.385.39.39.391 1.02.391 2.276l-.006.832c-.018.724-.092 1.15-.385 1.444-.39.39-1.018.39-2.275.39l-.831-.005c-.665-.017-1.08-.08-1.37-.316l-.075-.07c-.293-.292-.367-.719-.385-1.444L8 11.358C8 10.1 8 9.47 8.39 9.08c.31-.31.771-.373 1.577-.386V6.423h1.4z"
                fill="currentColor"
            />
            <path
                d="M.977.259c.477-.4 1.204-.271 2.657-.013l2.197.39.001 4.386H.5V2.356h.004C.51 1.22.559.61.977.26"
                fill="currentColor"
            />
            <path
                d="M14.303 2.144A1.45 1.45 0 0 1 15.5 3.572l-.008.148a1.45 1.45 0 0 1-1.443 1.302H7.23V.886z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CraneFilledSize16Glyph.displayName = 'CraneFilledSize16Glyph';
